<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" v-if="!topNav"/>
    <top-nav id="topmenu-container" class="topmenu-container" v-if="topNav"/>

    <div class="right-menu">
      <template v-if="device!=='mobile'">
<!--        <search id="header-search" class="right-menu-item" />-->
        <screenfull id="screenfull" class="right-menu-item hover-effect" />
<!--        <el-tooltip content="布局大小" effect="dark" placement="bottom">-->
<!--          <size-select id="size-select" class="right-menu-item hover-effect" />-->
<!--        </el-tooltip>-->
      </template>
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
<!--          <img :src="avatar" class="user-avatar">-->
          {{name}}
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/setting/companyInfo">
            <el-dropdown-item>基本资料</el-dropdown-item>
          </router-link>
<!--          <router-link to="/user/profile">-->
<!--            <el-dropdown-item>个人中心</el-dropdown-item>-->
<!--          </router-link>-->
<!--          <el-dropdown-item @click.native="setting = true">-->
<!--            <span>布局设置</span>-->
<!--          </el-dropdown-item>-->
          <el-dropdown-item divided @click.native="logout">
            <span>退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="right-menu mr20 top-link" v-if="userType ==='2' || userType ==='6'"><!-- 只有厂家端下显示 -->
      <div class="msg-list"><svg-icon icon-class="sf_msg" /> <router-link to="/operate/announce">消息中心</router-link><span v-if="amountMsg.unreadMsgCount >0"></span></div>
      <div class="right-line"></div>
    </div>
    <div class="right-menu mr20 top-link" v-if="userType !=='1' && userType !=='4' && userType !=='2' && userType !=='6'"><!-- 平台/品牌商下不显示 -->
      <div><svg-icon icon-class="sf_help2" /> <router-link to="/msg/useIndex">帮助中心</router-link></div>
      <div class="right-line"></div>
    </div>
    <div class="right-menu mr20 top-link" v-if="userType ==='1' || userType ==='4'"><!-- 只有平台端显示 -->
      <div><svg-icon icon-class="sf_note" /> 可用短信数量：{{complaintMsg.smsCount}}</div>
      <div class="right-line"></div>
    </div>
    <div class="right-menu mr20 top-link" v-if="userType ==='1' || userType ==='4'"><!-- 只有平台端显示 -->
      <div><svg-icon icon-class="sf_tous" /> 投诉：{{complaintMsg.complaintCount}} </div>
      <div class="right-line"></div>
    </div>
    <div class="right-menu mr20 top-link" v-if="userType ==='2' || userType ==='6'"><!-- 只有厂家端显示 -->
      <div><!--<svg-icon icon-class="sf_kyye" />--> 可用余额</div>
      <div class="ml10">
        <span style="font-size: 16px; color: #FF0000">￥{{amountMsg.amount}}</span>
        <el-button type="success" size="mini" class="ml10" round @click="recharge">去充值</el-button>
      </div>
      <div class="right-line"></div>
    </div>
    <div class="right-menu mr20 top-link" v-if="userType ==='3' || userType ==='5'"><!-- 只有服务商端显示 -->
      <div><svg-icon icon-class="sf_kyye" /> 备件押金金额</div>
      <div class="ml10">
        <span style="font-size: 16px; color: #FF0000">￥{{fittingMoney}}</span>
        <el-button type="success" size="mini" class="ml10" round @click="recharge">去充值</el-button>
      </div>
      <div class="right-line"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import TopNav from '@/components/TopNav'
import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import Search from '@/components/HeaderSearch'
import { getFactoryAmountMsg, getIndexMessageComplaintCount, getSiteFittingDeposit } from '@/api/index'
import Cookies from 'js-cookie'
import Bus from '@/api/bus';


export default {
  components: {
    Breadcrumb,
    TopNav,
    Hamburger,
    Screenfull,
    SizeSelect,
    Search,
  },
  data(){
    return {
      userType: Cookies.get('userType'),
      amountMsg: {},//厂家
      complaintMsg: {},//平台
      fittingMoney: '',//服务商
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'name',
      'device'
    ]),
    setting: {
      get() {
        return this.$store.state.settings.showSettings
      },
      set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'showSettings',
          value: val
        })
      }
    },
    topNav: {
      get() {
        return this.$store.state.settings.topNav
      }
    }
  },
  mounted() {
    if(this.userType ==='2' || this.userType ==='6'){
      this.getFactoryAmountMsg();
    }else if(this.userType ==='1' || this.userType ==='4'){
      this.getIndexMessageComplaintCount();
    }else{
      this.getSiteFittingDeposit();
    }
    Bus.$on('updateBalance', m => {
      if(m){
        if(this.userType ==='2' || this.userType ==='6'){//厂家
          this.getFactoryAmountMsg();
        }else if(this.userType ==='3' || this.userType ==='5'){//服务商
          this.getSiteFittingDeposit();
        }
      }
    });
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      this.$confirm('确定注销并退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('LogOut').then(() => {
          location.href = this.getHomeUrl+'/index';
          // location.reload()
        })
      }).catch(() => {});
    },
    //账户金额/判断是否有最新消息
    getFactoryAmountMsg() {
      getFactoryAmountMsg().then(response => {
        if (response.code === 200) {
          this.amountMsg = response.data
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //平台首页的短信数量及投诉数量
    getIndexMessageComplaintCount() {
      getIndexMessageComplaintCount().then(response => {
        if (response.code === 200) {
          this.complaintMsg = response.data
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    //服务商端首页备件押金金额
    getSiteFittingDeposit() {
      getSiteFittingDeposit().then(response => {
        if (response.code === 200) {
          this.fittingMoney = response.data
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
    recharge(){
      this.$router.push({path:'/recharge'})
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  .top-link{
    display: flex;
    align-items: center;
    font-size: 12px;
    .right-line{height: 16px; width: 1px; background: #CCC; margin-left: 15px;}
    .msg-list{
      position: relative;
      span{
        display: inline-block;
        width: 5px; height: 5px;
        background-color: #ff3600; border-radius: 10px;
        position: absolute; top: 18px; left: 7px;
      }
    }
  }
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .topmenu-container {
    position: absolute;
    left: 50px;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        /*margin-top: 5px;*/
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 20px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
